export interface CreateAdSetRequest {
  placement_id: string;
  shopper_key?: string | null;
  store_key?: string | null;
  category_key?: string | null;
  keyword?: string | null;
  skus?: string[] | null;
  session_key?: string | null;
  custom_targeting?: { [key: string]: any } | null;
  geo?: { lat: number; lon: number } | null;
}

export interface RawAdSetApiResponse {
  id: string;
  placement_id: string;
  ad_source: AdSetAdSourceEnum;
  ads: Ad[];
  store_key?: string | null;
  category_key?: string | null;
  keyword?: string | null;
  skus?: string[] | null;
  shopper_key?: string | null;
  custom_targeting?: any;
}

export enum AdDiscountTypeEnum {
  Percentage = 'PERCENTAGE',
  Absolute = 'ABSOLUTE',
}

export interface Ad {
  id: string;
  position: number;
  campaign_id: string;
  line_item_id: string;
  advertised_skus?: string[];
  recommended_sku?: string;
  tracking_token?: string | null;
  bid_cents: number | null;
  discount_value?: number;
  discount_type?: AdDiscountTypeEnum;
  creatives?: { [key: string]: CreativesValue } | null;
  link_url?: string;
  headline?: string;
  custom?: any;
}

export interface CreativesValue {
  url: string;
  duration?: number;
}

enum AdSetAdSourceEnum {
  ApiResponded = 'API_RESPONDED',
  BulkCreated = 'BULK_CREATED',
}
